import { useTheme } from '@emotion/react';
import { Fragment } from 'react';

import Flex from 'shopper/components/Flex';
import Link from 'shopper/components/Link';

import { isLastItem } from 'lib/array';
import { toLandingPageLink } from 'lib/links';

import FOOTER from 'constants/footer';
import LANDINGS from 'constants/landings';
import LINKS from 'constants/links';

const PAGES_LINKS_LIST = [
  { name: FOOTER.PAGES.WHAT_IS, href: LINKS.PROMOBIT_WHAT_IS },
  { name: FOOTER.PAGES.BLACK_FRIDAY, href: toLandingPageLink('black-friday') },
  { name: FOOTER.PAGES.BUSINESS, href: LINKS.BUSINESS },
  { name: FOOTER.PAGES.COMPARAI, href: LINKS.COMPARAI },
  {
    name: FOOTER.PAGES.USE_TERMS,
    href: toLandingPageLink('termos', LANDINGS.TYPES.INSTITUTIONAL),
  },
  { name: FOOTER.PAGES.SITEMAP, href: LINKS.SITEMAP },
  {
    name: FOOTER.PAGES.PRIVACY,
    href: toLandingPageLink(
      'politica-de-privacidade',
      LANDINGS.TYPES.INSTITUTIONAL
    ),
  },
  { name: FOOTER.PAGES.COOKIES, href: LINKS.COOKIES_POLICY },
];

const FooterMiddle = () => {
  const theme = useTheme();

  return (
    <Flex
      borderTop="2px solid"
      borderBottom="2px solid"
      justifyContent="center"
      px={4}
      borderColor={theme.app.footer.dividerBg}
      py={[6, null, 4]}
      full
    >
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        mx={[3, null, 0]}
      >
        {PAGES_LINKS_LIST.map(({ name, href }, index, arr) => (
          <Fragment key={name}>
            <Link
              size="size2"
              type="secondary"
              href={href}
              mx={2}
              py={[2, null, null, 0]}
            >
              {name}
            </Link>
            {!isLastItem(arr, index) && '•'}
          </Fragment>
        ))}
      </Flex>
    </Flex>
  );
};

export default FooterMiddle;
